import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { isValidCountry } from '@lib/geotargeting/countryValidation';
import { RootState } from '@lib/redux.lib/store';

type UseUserCountry = {
  userCountry: ProductionCountry;
  isUkUser: boolean;
};

export const useUserCountry = (): UseUserCountry => {
  const rawUserCountry = useSelector(
    (state: RootState) => state.app.user.profile?.selected_country
  );
  const userCountry = useMemo<ProductionCountry>(() => {
    if (!rawUserCountry || !isValidCountry(rawUserCountry)) {
      return 'US';
    }
    return rawUserCountry;
  }, [rawUserCountry]);

  const isUkUser = useMemo(() => userCountry === 'UK', [userCountry]);
  return { userCountry, isUkUser };
};
